import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { CONTACTS_LOCAL_API_REQUESTS } from './utils/constants';

export const getBusinessContacts = async (
  businessId,
  activeEmployerInfo = {}
) => {
  const apiPath = `contacts/business/${businessId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest: CONTACTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
